<template>
  <dialog-info
    ref="dialog"
    :title="title"
    @close="handlerClose"
    customClass="dialog-connect-open-po"
  >
    <list-form
      ref="list-form"
      :formModel="formModel"
      :config="config"
    >
      <template v-slot="{ data, item, autoSave }">
        <activity-item-po
          :data="data"
          :item="item"
          :formModel="formModel"
          :autoSave="autoSave"
          @onSendEmail="handlerSendEmail"
          @updatedData="refresh"
        >
        </activity-item-po>
      </template>
    </list-form>
  </dialog-info>
</template>

<script>
import { waitValue } from '@/utils/promises'
import { ModelOpenPO } from '@/models/RepairExchangeOrder'
import listFormConfig from './ListFormConfig'
export default {
  name: 'DialogConnectToOpenPO',
  components: {
    'dialog-info': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogInfo'),
    'list-form': () => import(/* webpackChunkName: 'ListForm' */ '@/components/ListForm/Index'),
    'activity-item-po': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityItemOpenPO/Index')
  },
  props: {
    filterFieldName: { type: String, default: 'rfqid' },
    filterValueTemplate: {
      type: Function,
      default: (filterValue) => {
        return `rfqid == "${filterValue}"`
      }
    }
  },
  data () {
    return {
      filterValue: null,
      data: {},
      config: listFormConfig
    }
  },
  computed: {
    title () {
      return this.filterValue
    }
  },
  methods: {
    formModel () {
      return new ModelOpenPO()
    },
    refresh () {
      this.getListForm()
        .then((listForm) => {
          listForm.refresh()
        })
    },
    getListForm () {
      return waitValue(() => this.$refs['list-form'])
    },
    loadData () {
      if (!this.filterValue) return
      this.getListForm()
        .then((listForm) => {
          listForm.setFilters(this.filterValueTemplate(this.filterValue))
          listForm.loadData()
        })
    },
    show (data) {
      this.filterValue = data[this.filterFieldName]
      this.$refs['dialog'].show()
      this.loadData()
    },
    hide () {
      this.$refs['dialog'].hide()
    },
    handlerClose () {
      this.getListForm()
        .then((listForm) => {
          listForm.clear()
        })
    },
    handlerSendEmail () {
      this.$emit('onSendEmail', ...arguments)
    }
  }
}
</script>
<style lang="stylus">
  .dialog-connect-open-po.el-dialog{
    max-width 130rem
  }
</style>
